<template>
  <div id="information">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends—GF小程序资讯页</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          plain
          @click="searchBtn"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="el-icon-notebook-2"
          plain
          @click="
            (createVisible = true),
              (title = 'GIADA Friends—GF小程序资讯页—创建')
          "
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="el-icon-edit-outline"
          plain
          @click="editShow(), (title = 'GIADA Friends—GF小程序资讯页—修改')"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="el-icon-delete"
          plain
          @click="deleteFormVisibleShow()"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          plain
          @click="examineVisibleShow()"
          >查看</el-button
        >
      </div>
    </div>
    <!--创建弹窗  -->
    <div class="create">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="选择资讯类型"
        :visible.sync="createVisible"
      >
        <div
          style="
            width: 320px;
            height: 50px;
            margin-top: 10px;
            margin-left: 30px;
          "
        >
          <el-button
            @click="
              (createShow = true),
                (createVisible = false),
                (createFormData.recordType = 1)
            "
            >品牌资讯</el-button
          >
          <el-button
            @click="
              (createShow = true),
                (createVisible = false),
                (createFormData.recordType = 2)
            "
            >产品动态</el-button
          >
          <el-button
            @click="
              (createShow = true),
                (createVisible = false),
                (createFormData.recordType = 3)
            "
            >邀请新客</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!--修改弹窗  -->
    <div class="amend">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="选择记录类型"
        :visible.sync="amendVisible"
      >
        <div
          style="
            width: 320px;
            height: 50px;
            margin-top: 10px;
            margin-left: 30px;
          "
        >
          <el-button @click="(afterVisible = true), (amendVisible = false)"
            >品牌资讯</el-button
          >
          <el-button @click="(fittinVisible = true), (amendVisible = false)"
            >产品动态</el-button
          >
          <el-button @click="(fittinVisible = true), (amendVisible = false)"
            >邀请新客</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 查看弹窗  -->
    <div class="examine">
      <el-dialog
        :close-on-click-modal="false"
        width="800px"
        :title="
          'GF小程序资讯页—查看(' +
          (formData.recordType == 1
            ? '品牌资讯'
            : formData.recordType == 2
            ? '产品动态'
            : '邀请新客') +
          ')'
        "
        :visible.sync="examineVisible"
      >
        <div class="flex-between" style="padding: 20px 20px 40px 20px">
          <div style="height: 90px">
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="150px"
              :model="formData"
            >
              <el-form-item label="GF小程序资讯页编号">
                <el-input v-model="formData.appletCode" disabled></el-input>
              </el-form-item>
              <el-form-item label="是否启用">
                <el-select v-model="formData.isActive" disabled>
                  <el-option
                    v-for="item in optionState"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="板块编号" v-if="formData.recordType != 3">
                <el-select
                  v-model="formData.partNO"
                  disabled
                  v-if="formData.recordType == 1"
                >
                  <el-option value="B1" label="B1" key="B1"></el-option>
                  <el-option value="B2" label="B2" key="B2"></el-option>
                  <el-option value="B3" label="B3"></el-option>
                  <el-option value="B4" label="B4"></el-option>
                </el-select>
                <el-select v-model="formData.partNO" disabled v-else>
                  <el-option value="P1" label="P1"></el-option>
                  <el-option value="P2" label="P2"></el-option>
                  <el-option value="P3" label="P3"></el-option>
                  <el-option value="P4" label="P4"></el-option>
                  <el-option value="P5" label="P5"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div style="height: 90px">
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="150px"
              :model="formData"
            >
              <el-form-item label="资讯类型">
                <el-select disabled v-model="formData.recordType">
                  <el-option
                    v-for="item in realTimeInfo"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div style="height: 30px; background-color: #ccc; line-height: 30px">
          <span style="margin: 20px 0 0 20px; font-weight: 700">页面内容</span>
        </div>
        <div style="margin-top: 20px; padding: 0 20px 0 20px">
          <el-form
            v-if="formData.recordType == 2"
            size="mini"
            :label-position="labelPosition"
            label-width="140px"
            :model="formData"
            :inline="true"
          >
            <el-form-item label="封面大标题">
              <el-input
                type="textarea"
                v-model="formData.bigHeadLine"
                disabled
              ></el-input>
            </el-form-item>

            <el-form-item label="封面小标题">
              <el-input
                type="textarea"
                v-model="formData.smallHeadLine"
                disabled
              ></el-input>
            </el-form-item>
          </el-form>

          <el-form
            size="mini"
            :label-position="labelPosition"
            label-width="140px"
            :model="formData"
          >
            <el-form-item label="封面图片链接" v-if="formData.recordType != 3">
              <el-input
                readonly
                value="规格：长*宽；格式：gpj、bmp；大小：xxMB"
              ></el-input>
            </el-form-item>
            <el-form-item label v-if="formData.recordType != 3">
              <div>
                <span style="color: #c9b916">说明:最多1张图片</span>
              </div>
            </el-form-item>
            <el-form-item label v-if="formData.recordType != 3">
              <el-image
                style="
                  width: 150px;
                  height: 150px;
                  margin: 5px 0px;
                  border: 1px solid #e4e7ed;
                "
                :src="formData.partImageUrl"
                :preview-src-list="[formData.partImageUrl]"
              ></el-image>
              <!-- <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
              </el-upload>-->
            </el-form-item>
            <el-form-item label="详细内容图片">
              <el-input
                value="说明：最多5张图片，规格：长*宽；格式：gpj、bmp；大小：xxMB"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label>
              <div>
                <span style="color: #c9b916">说明:最多5张图片</span>
              </div>
            </el-form-item>
            <!-- <el-form-item label=""> -->

            <el-form-item>
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  height: 400px;
                "
              >
                <div>
                  <el-image
                    style="
                      width: 150px;
                      height: 150px;
                      margin: 5px 10px 0 0;
                      border: 1px solid #e4e7ed;
                    "
                    :src="formData.partImgUrl1"
                    :preview-src-list="[formData.partImgUrl1]"
                  ></el-image>

                  <el-image
                    style="
                      width: 150px;
                      height: 150px;
                      margin: 5px 10px 0 0;
                      border: 1px solid #e4e7ed;
                    "
                    v-if="formData.partImgUrl2"
                    :src="formData.partImgUrl2"
                    :preview-src-list="[formData.partImgUrl2]"
                  ></el-image>

                  <el-image
                    style="
                      width: 150px;
                      height: 150px;
                      margin: 5px 10px 0 0;
                      border: 1px solid #e4e7ed;
                    "
                    v-if="formData.partImgUrl3"
                    :src="formData.partImgUrl3"
                    :preview-src-list="[formData.partImgUrl3]"
                  ></el-image>

                  <el-image
                    style="
                      width: 150px;
                      height: 150px;
                      margin: 5px 10px 0 0;
                      border: 1px solid #e4e7ed;
                    "
                    v-if="formData.partImgUrl4"
                    :src="formData.partImgUrl4"
                    :preview-src-list="[formData.partImgUrl4]"
                  ></el-image>

                  <el-image
                    style="
                      width: 150px;
                      height: 150px;
                      margin: 5px 10px 0 0;
                      border: 1px solid #e4e7ed;
                    "
                    v-if="formData.partImgUrl5"
                    :src="formData.partImgUrl5"
                    :preview-src-list="[formData.partImgUrl5]"
                  ></el-image>
                </div>
              </div>
            </el-form-item>
            <div style="clear: both"></div>
            <el-form-item label="详细内容跳转链接">
              <el-input v-model="formData.imgHtmlUrl" disabled></el-input>
            </el-form-item>
            <!-- </el-form-item> -->
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="examineVisible = false" size="small"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="删除小程序咨询页确认取消对话框"
        :visible.sync="deleteFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要
            <span style="color: #ff0000">删除</span>GF小程序咨询页信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitDelete()">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 创建弹窗 -->
    <div class="examine">
      <el-dialog
        :close-on-click-modal="false"
        width="800px"
        :title="
          title +
          '(' +
          (createFormData.recordType == 1
            ? '品牌资讯'
            : createFormData.recordType == 2
            ? '产品动态'
            : '邀请新客') +
          ')'
        "
        :visible.sync="createShow"
      >
        <div class="flex-between" style="padding: 20px 20px 40px 20px">
          <div style="height: 90px">
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="150px"
              :model="createFormData"
              ref="createRef"
              :rules="rules"
            >
              <el-form-item label="GF小程序资讯页编号">
                <el-input v-model="createFormData.appletCode"></el-input>
              </el-form-item>
              <el-form-item label="是否启用" prop="isActive">
                <el-select v-model="createFormData.isActive">
                  <el-option
                    v-for="item in optionState"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="板块编号"
                v-if="createFormData.recordType != 3"
              >
                <el-select
                  v-model="createFormData.partNO"
                  v-if="createFormData.recordType == 1"
                >
                  <el-option value="B1" label="B1" key="B1"></el-option>
                  <el-option value="B2" label="B2" key="B2"></el-option>
                  <el-option value="B3" label="B3"></el-option>
                  <el-option value="B4" label="B4"></el-option>
                </el-select>
                <el-select v-model="createFormData.partNO" v-else>
                  <el-option value="P1" label="P1"></el-option>
                  <el-option value="P2" label="P2"></el-option>
                  <el-option value="P3" label="P3"></el-option>
                  <el-option value="P4" label="P4"></el-option>
                  <el-option value="P5" label="P5"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div style="height: 90px">
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="150px"
              :model="createFormData"
            >
              <el-form-item label="资讯类型">
                <el-select disabled v-model="createFormData.recordType">
                  <el-option
                    v-for="item in realTimeInfo"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div style="height: 30px; background-color: #ccc; line-height: 30px">
          <span style="margin: 20px 0 0 20px; font-weight: 700">页面内容</span>
        </div>
        <div style="margin-top: 20px; padding: 0 20px 0 20px">
          <el-form
            v-if="createFormData.recordType == 2"
            size="mini"
            :label-position="labelPosition"
            label-width="140px"
            :model="createFormData"
            :inline="true"
          >
            <el-form-item label="封面大标题">
              <el-input
                type="textarea"
                v-model="createFormData.bigHeadLine"
              ></el-input>
            </el-form-item>

            <el-form-item label="封面小标题">
              <el-input
                type="textarea"
                v-model="createFormData.smallHeadLine"
              ></el-input>
            </el-form-item>
          </el-form>

          <el-form
            size="mini"
            :label-position="labelPosition"
            label-width="140px"
            :model="createFormData"
          >
            <el-form-item
              label="封面图片链接"
              v-if="createFormData.recordType != 3"
            >
              <el-input
                readonly
                value="规格：长*宽；格式：gpj、bmp；大小：xxMB"
              ></el-input>
            </el-form-item>
            <el-form-item label v-if="createFormData.recordType != 3">
              <div>
                <span style="color: #c9b916">说明:最多1张图片</span>
              </div>
            </el-form-item>
            <el-form-item label v-if="createFormData.recordType != 3">
              <div
                style="
                  display: flex;
                  width: 85%;
                  flex-wrap: wrap;
                  height: 200px;
                "
              >
                <div v-if="createFormData.partImageUrl">
                  <el-image
                    style="
                      width: 150px;
                      height: 150px;
                      margin: 5px 10px 0 0;
                      border: 1px solid #e4e7ed;
                    "
                    :src="createFormData.partImageUrl"
                    :preview-src-list="[createFormData.partImageUrl]"
                  ></el-image>
                  <el-button
                    @click="createFormData.partImageUrl = ''"
                    type="danger"
                    icon="el-icon-close"
                    style="position: relative; top: -150px; left: -15px"
                    circle
                  ></el-button>
                </div>

                <el-upload
                  v-if="createFormData.partImageUrl == ''"
                  style="width: 150px; height: 150px; margin: 10px 15px"
                  class="avatar-uploader"
                  :action="uploadUrl"
                  :headers="headersObj"
                  :on-success="handleAvatarSuccess1"
                  :show-file-list="false"
                  list-type="picture-card"
                  :before-upload="beforeAvatarUpload1"
                  :data="uploadData"
                >
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="详细内容图片">
              <el-input
                value="说明：最多5张图片，规格：长*宽；格式：gpj、bmp；大小：xxMB"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label>
              <div>
                <span style="color: #c9b916">说明:最多5张图片</span>
              </div>
            </el-form-item>
            <!-- <el-form-item label=""> -->

            <el-form-item>
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  height: 400px;
                "
              >
                <div v-for="(item, index) in imageArray" :key="index">
                  <el-image
                    style="
                      width: 150px;
                      height: 150px;
                      margin: 5px 10px 0 0;
                      border: 1px solid #e4e7ed;
                    "
                    :src="item"
                    :preview-src-list="[item]"
                  ></el-image>
                  <el-button
                    @click="deleteImg(index)"
                    type="danger"
                    icon="el-icon-close"
                    style="position: relative; top: -150px; left: -15px"
                    circle
                  ></el-button>
                </div>

                <el-upload
                  v-if="imageArray.length < 5"
                  style="width: 150px; height: 150px; margin: 10px 15px"
                  class="avatar-uploader"
                  :action="uploadUrl"
                  :headers="headersObj"
                  :on-success="handleAvatarSuccess"
                  :show-file-list="false"
                  list-type="picture-card"
                  :before-upload="beforeAvatarUpload"
                  :data="uploadData"
                >
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
            <div style="clear: both"></div>
            <el-form-item label="详细内容跳转链接">
              <el-input v-model="createFormData.imgHtmlUrl"></el-input>
            </el-form-item>
            <!-- </el-form-item> -->
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="preservation()" size="small">保 存</el-button>
          <el-button
            @click="
              (createShow = false),
                resetform(),
                (templatei = ''),
                (radioxz = '')
            "
            size="small"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>

    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          :model="formLabelAlign"
          size="small"
          :inline="true"
        >
          <el-form-item label="板块编号">
            <el-input v-model="searchForm.partNO"></el-input>
          </el-form-item>
          <el-form-item label="封面大标题">
            <el-input v-model="searchForm.bigHeadLine"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 100%" v-model="searchForm.isActive">
              <el-option :value="null" label="全部"></el-option>
              <el-option
                v-for="item in optionState"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面小标题">
            <el-input v-model="searchForm.smallHeadLine"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div>
      <el-card shadow="never" class="card-center" style="margin-top: 10px">
        <el-table
          height="530px"
          size="small"
          class="table-style"
          highlight-current-row
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index" width="55"></el-table-column>
          <el-table-column label width="30">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radioxz"
                @change.native="getCurrentRow(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column prop="appletCode" label="小程序资讯页编号">
            <template slot-scope="scope">
              <div
                v-if="jurisdiction.look"
                class="ConponesName"
                @click="examineVisibleShow(scope.row)"
                href="#"
              >
                {{ scope.row.appletCode }}
              </div>
              <div v-else class="ConponesName" href="#">
                {{ scope.row.appletCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="partNO" label="板块编号"></el-table-column>
          <el-table-column prop="isActive" label="是否启用">
            <template slot-scope="scope">{{
              scope.row.isActive ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column prop="recordType" label="资讯类型">
            <template slot-scope="scope">
              {{
                scope.row.recordType == 1
                  ? "品牌资讯"
                  : scope.row.recordType == 2
                  ? "产品动态"
                  : "邀请新客"
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="smallHeadLine"
            label="封面小标题"
          ></el-table-column>
          <el-table-column
            prop="bigHeadLine"
            label="封面大标题"
          ></el-table-column>

          <el-table-column
            prop="createUserName"
            label="创建人"
          ></el-table-column>
          <el-table-column prop="createTime" label="创建日期">
            <template slot-scope="scope">
              <div v-if="scope.row.createTime !== null">
                {{ scope.row.createTime | dateFormat }}
              </div>
              <div v-else></div>
            </template>
          </el-table-column>

          <el-table-column
            prop="updateUserName"
            label="最后修改人"
          ></el-table-column>
          <el-table-column prop="updateTime" label="最后修改日期">
            <template slot-scope="scope">
              <div v-if="scope.row.updateTime !== null">
                {{ scope.row.updateTime | dateFormat }}
              </div>
              <div v-else></div>
            </template>
          </el-table-column>

          <!-- <el-table-column label="操作" align="center" min-width="100">
            <template slot-scope="scope">
              <div class="table-button">
                <el-button
                  size="mini"
                  title="查看"
                  icon="iconfont icon-chakan1"
                  @click="examineVisibleShow(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="修改"
                  icon="iconfont icon-xiugai1"
                  @click="
                    editShow(scope.row),
                      (title = 'GIADA Friends—GF小程序资讯页—修改')
                  "
                ></el-button>
                <el-button
                  size="mini"
                  title="删除"
                  icon="iconfont icon-a-shanchu11"
                  @click="deleteFormVisibleShow(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <el-alert
          v-if="total <= tableData.length"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        ></el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  lectInfoPageApi,

  deleteRealTimeInfo,
  addRealTimeInfo,
  updateRealTimeInfo,
} from "@/api/friends";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  data() {
    return {
      uploadData: {
        type: 5,
      },
      loading: false,
      realTimeInfo: [
        {
          value: 1,
          label: "品牌资讯",
        },
        {
          value: 2,
          label: "产品动态",
        },
        {
          value: 3,
          label: "邀请新客",
        },
      ], //资讯类型
      imageUrl: "",
      uploadUrl: "/api/api/uploadImg",
      headersObj: {
        Authorization: window.localStorage.getItem("token"),
      },
      deleteFormVisible: false,
      examineVisible: false,
      fittinVisible: false,
      afterVisible: false,
      amendVisible: false,
      inviteVisible: false,
      fittingVisible: false,
      saleVisible: false,
      createVisible: false,
      labelPosition: "right",
      labelPosition2: "top",
      //搜索
      searchForm: {
        partNo: "",
        bigHeadLine: "",
        smallHeadLine: "",
        isActive: "",
        pageNo: 1,
        pageSize: 20,
      },
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      // 状态
      optionState: [
        {
          value: false,
          label: "否",
        },
        {
          value: true,
          label: "是",
        },
      ],
      queryInfo: {
        pageNo: 1,
        pageSize: 20,
      },
      tableData: [],
      total: 0,
      size: 0,
      establishForm: { shopImg1: "" },
      saveModifyFrom: { shopImg1: "" },
      imageArray: [],
      formData: {},
      radioxz: "",
      createFormData: {
        appletCode: "",
        bigHeadLine: "",
        cpyNO: getcpyNo(),
        imgHtmlUrl: "",
        isActive: "",
        partImageUrl: "",
        partImgUrl1: "",
        partImgUrl2: "",
        partImgUrl3: "",
        partImgUrl4: "",
        partImgUrl5: "",
        partImgUrl6: "",
        partNO: "",
        recordType: "",
        smallHeadLine: "",
      }, //创建表单数据
      createShow: false,
      title: "",
      templatei: {},
      // 新增表单验证规则
      rules: {
        isActive: [
          { required: true, message: "请选择是否启用", trigger: "blur" },
        ],
      },
      bodyStyle: {
        padding: "0px",
      },
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        delete: false,
        look: false,
      },
    };
  },
  created() {
    this.loading = true;
    this.tableList();
    let Information = JSON.parse(localStorage.getItem("Information"));
    console.log(Information);
    for (let i = 0; i < Information.length; i++) {
      if (Information[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Information[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Information[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }

      if (Information[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }

      if (Information[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
  },
  computed: {
    onLoading() {
      console.log(this.total, this.tableData.length);
      return this.loading || this.total < this.tableData.length;
    },
  },
  methods: {
    load() {
      setTimeout(() => {
        if (this.total > this.tableData.length) {
          this.queryInfo.pageNo += 1;
          this.tableList();
        }
      }, 1000);
    },

    //打开修改
    editShow(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.appletInfoID) {
        this.createShow = true;
        this.createFormData = {
          appletInfoID: this.templatei.appletInfoID,
          appletCode: this.templatei.appletCode,
          bigHeadLine: this.templatei.bigHeadLine,
          cpyNO: getcpyNo(),
          imgHtmlUrl: this.templatei.imgHtmlUrl,
          isActive: this.templatei.isActive,
          partImageUrl: this.templatei.partImageUrl,
          partImgUrl1: this.templatei.partImgUrl1,
          partImgUrl2: this.templatei.partImgUrl2,
          partImgUrl3: this.templatei.partImgUrl3,
          partImgUrl4: this.templatei.partImgUrl4,
          partImgUrl5: this.templatei.partImgUrl5,
          partImgUrl6: this.templatei.partImgUrl6,
          partNO: this.templatei.partNO,
          recordType: this.templatei.recordType,
          smallHeadLine: this.templatei.smallHeadLine,
        };
        if (this.templatei.partImgUrl1) {
          this.imageArray.push(this.templatei.partImgUrl1);
        }
        if (this.templatei.partImgUrl2) {
          this.imageArray.push(this.templatei.partImgUrl2);
        }
        if (this.templatei.partImgUrl3) {
          this.imageArray.push(this.templatei.partImgUrl3);
        }
        if (this.templatei.partImgUrl4) {
          this.imageArray.push(this.templatei.partImgUrl4);
        }
        if (this.templatei.partImgUrl5) {
          this.imageArray.push(this.templatei.partImgUrl5);
        }
      } else {
        this.$message.error("请先选中一行数据");
      }
    },

    //重置创建表单
    resetform() {
      this.createFormData = {
        appletCode: "",
        bigHeadLine: "",
        cpyNO: getcpyNo(),
        imgHtmlUrl: "",
        isActive: "",
        partImageUrl: "",
        partImgUrl1: "",
        partImgUrl2: "",
        partImgUrl3: "",
        partImgUrl4: "",
        partImgUrl5: "",
        partImgUrl6: "",
        partNO: "",
        recordType: "",
        smallHeadLine: "",
      };
      this.imageArray = [];
    },
    //调用接口
    Interface() {
      let data = [];
      for (let i = 0; i < 5; i++) {
        if (!this.imageArray[i]) {
          data.push("");
        } else {
          data.push(this.imageArray[i]);
        }
      }

      this.createFormData.partImgUrl1 = data[0];
      this.createFormData.partImgUrl2 = data[1];
      this.createFormData.partImgUrl3 = data[2];
      this.createFormData.partImgUrl4 = data[3];
      this.createFormData.partImgUrl5 = data[4];
      this.radioxz = "";
      if (this.title == "GIADA Friends—GF小程序资讯页—创建") {
        addRealTimeInfo(this.createFormData).then((res) => {
          if ((res.message === "success")) {
            this.$message.success(res.message);
            this.createShow = false;
            this.tableData = [];
            this.queryInfo.pageNo = 1;
            this.tableList();
            this.resetform();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        updateRealTimeInfo(this.createFormData).then((res) => {
          if ((res.message === "success")) {
            this.$message.success(res.message);
            this.createShow = false;
            this.tableData = [];
            this.queryInfo.pageNo = 1;
            this.tableList();
            this.resetform();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    //保存
    preservation() {
      this.$refs.createRef.validate(async (valid) => {
        if (valid) {
          this.Interface();
        }
      });
    },

    //确定删除数据
    submitDelete() {
      deleteRealTimeInfo({
        appletInfoID: this.templatei.appletInfoID,
      }).then((res) => {
        if ((res.message === "success")) {
          this.$message.success(res.message);
          this.deleteFormVisible = false;
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.tableList();
          this.radioxz = "";
          this.templatei = {};
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //打开删除弹窗
    deleteFormVisibleShow(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.appletInfoID) {
        this.deleteFormVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //打开查看弹窗
    examineVisibleShow(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.appletCode) {
        this.formData = this.templatei;
        this.examineVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //删除对应下标图片
    deleteImg(index) {
      this.imageArray.splice(index, 1);
    },
    beforeAvatarUpload(file) {
      console.log(file);
      this.imageUrl = file.name;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data;
      this.imageArray.push(this.imageUrl);
      console.log(this.imageUrl);
      console.log(res, file);
    },

    beforeAvatarUpload1(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },

    handleAvatarSuccess1(res, file) {

      this.createFormData.partImageUrl = res.data;
      console.log(file.size);
      // this.imageUrl.push(URL.createObjectURL(file.raw))
    },

    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    async tableList() {
      this.loading = true;
      const res = await lectInfoPageApi(this.queryInfo);
      if (res.success !== true) return;
      this.tableData = this.tableData.concat(res.data.list);
      this.total = res.data.total;
      this.size = res.data.size;
      this.loading = false;
    },
    async searchBtn() {
      this.tableData = [];
      const res = await lectInfoPageApi(this.searchForm);
      if (res.success !== true) return;
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.size = res.data.size;
    },
    getCurrentRow(row) {
      this.templatei = row;
      console.log(this.templatei);
      this.formLabelAlign = this.templatei;
    },
  },
};
</script>
<style lang="scss" scoped>
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.header {
  .header-text {
    width: 32rem;
    height: 50px;
    // margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
//改变Upload 上传组件大小
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
}
/deep/ .el-upload {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .sale {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .fitting {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .invite {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .after {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .fittin {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .examine {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
